const hasBurnSubtitlesOn = (organization?: string): boolean => {
  if (!organization) return false;

  return ["merck", "msd", "microsoft", "comcast", "international rescue committee", "premise health"].includes(
    organization.toLowerCase()
  );
};

export default hasBurnSubtitlesOn;
